class Editor {
  constructor(el,opt){
    this.el = el;
    this.event();
  }
  event(){
    $('[class*="wp-image"]').each(function(index, el) {
      let width = $(el).attr('width');
      $(el).css({'width': `${width * 0.1 + 'rem'}`, 'height': `auto`})
    })
  }
}